import React from 'react';

import {Row, Col} from "react-bootstrap";
import Form from "react-bootstrap/Form";

import "../css/Components.css";

const RootOptions=({root, updateInput})=>(
	<Form.Group>
		<Form.Check 
			id="verb_root_p"
			type="radio"
			label="primary"
			name="verbRootOptions"
			checked={root === 'p'}
			onChange={()=>updateInput('root', 'p')}
		/>
		<Form.Check 
			id="verb_root_c"
			type="radio"
			label="c causitive"
			name="verbRootOptions"
			checked={root === 'c'}
			onChange={()=>updateInput('root', 'c')}
		/>
		<Form.Check 
			id="verb_root_d"
			type="radio"
			label="d desiderative"
			name="verbRootOptions"
			checked={root === 'd'}
			onChange={()=>updateInput('root', 'd')}
		/>
		<Form.Check 
			id="verb_root_i"
			type="radio"
			label="i intensive"
			name="verbRootOptions"
			checked={root === 'i'}
			onChange={()=>updateInput('root', 'i')}
		/>
	</Form.Group>
);

const TenseOptions=({updateInput})=>(
	<Form.Group>
		<Form.Check 
			id="verb_tense_pre"
			type="radio"
			label="pre present"
			name="verbTenseOptions"
			onClick={()=>updateInput('tense', 'pre')}
		/>
		<Form.Check 
			id="verb_tense_ipf"
			type="radio"
			label="ipf imperfect"
			name="verbTenseOptions"
			onClick={()=>updateInput('tense', 'ipf')}
		/>
		<Form.Check 
			id="verb_tense_ipv"
			type="radio"
			label="ipv imperative"
			name="verbTenseOptions"
			onClick={()=>updateInput('tense', 'ipv')}
		/>
		<Form.Check 
			id="verb_tense_pop"
			type="radio"
			label="pop present optative"
			name="verbTenseOptions"
			onClick={()=>updateInput('tense', 'pop')}
		/>
		<Form.Check 
			id="verb_tense_pij"
			type="radio"
			label="pij present injuctive"
			name="verbTenseOptions"
			onClick={()=>updateInput('tense', 'pij')}
		/>
		<Form.Check 
			id="verb_tense_fut"
			type="radio"
			label="fut future"
			name="verbTenseOptions"
			onClick={()=>updateInput('tense', 'fut')}
		/>
		<Form.Check 
			id="verb_tense_con"
			type="radio"
			label="con conditional"
			name="verbTenseOptions"
			onClick={()=>updateInput('tense', 'con')}
		/>
		<Form.Check 
			id="verb_tense_pft"
			type="radio"
			label="pft periphrastic future"
			name="verbTenseOptions"
			onClick={()=>updateInput('tense', 'pft')}
		/>
		<Form.Check 
			id="verb_tense_prf"
			type="radio"
			label="prf perfect"
			name="verbTenseOptions"
			onClick={()=>updateInput('tense', 'prf')}
		/>
		<Form.Check 
			id="verb_tense_aor"
			type="radio"
			label="aor aorist"
			name="verbTenseOptions"
			onClick={()=>updateInput('tense', 'aor')}
		/>
		<Form.Check 
			id="verb_tense_aop"
			type="radio"
			label="aop aorist optative"
			name="verbTenseOptions"
			onClick={()=>updateInput('tense', 'aop')}
		/>
		<Form.Check 
			id="verb_tense_aij"
			type="radio"
			label="aij aorist injuctive"
			name="verbTenseOptions"
			onClick={()=>updateInput('tense', 'aij')}
		/>

	</Form.Group>
);

const VoiceOptions=({updateInput})=>(
	<Form.Group>
		<Form.Check 
			id="verb_voice_a"
			type="radio"
			label="a active"
			name="verbVoiceOptions"
			onClick={()=>updateInput('voice', 'a')}
		/>
		<Form.Check 
			id="verb_voice_m"
			type="radio"
			label="m middle"
			name="verbVoiceOptions"
			onClick={()=>updateInput('voice', 'm')}
		/>
		<Form.Check 
			id="verb_voice_p"
			type="radio"
			label="p passive"
			name="verbVoiceOptions"
			onClick={()=>updateInput('voice', 'p')}
		/>
	</Form.Group>
);
const PersonOptions=({updateInput})=>(
	<Form.Group>
		<Form.Check 
			id="verb_person_1"
			type="radio"
			label="1 first"
			name="verbPersonOptions"
			onClick={()=>updateInput('person', '1')}
		/>
		<Form.Check 
			id="verb_person_2"
			type="radio"
			label="2 second"
			name="verbPersonOptions"
			onClick={()=>updateInput('person', '2')}
		/>
		<Form.Check 
			id="verb_person_3"
			type="radio"
			label="3 third"
			name="verbPersonOptions"
			onClick={()=>updateInput('person', '3')}
		/>
	</Form.Group>
);
const NumberOptions=({updateInput})=>(
	<Form.Group>
		<Form.Check 
			id="verb_number_s"
			type="radio"
			label="s singular"
			name="verbNumberOptions"
			onClick={()=>updateInput('number', 's')}
		/>
		<Form.Check 
			id="verb_number_d"
			type="radio"
			label="d dual"
			name="verbNumberOptions"
			onClick={()=>updateInput('number', 'd')}
		/>
		<Form.Check 
			id="verb_number_p"
			type="radio"
			label="p plural"
			name="verbNumberOptions"
			onClick={()=>updateInput('number', 'p')}
		/>
	</Form.Group>
);

const Verb=({inputParts, setInputParts})=>{

	const updateInput=(key, value)=>{
		setInputParts((prev) => ({ ...prev, [key]: value }));
	}

	return (
		<>
		<Row>
			<Col md="auto" className="interfaceCol">
				<div className="colHeader">
					<span className="spChar">R</span>oot type
				</div>
				<RootOptions root={inputParts.root} updateInput={(key, value)=>updateInput(key, value)}/>
			</Col>
			<Col md='auto' className="interfaceCol">
				<div className="colHeader">
					<span className="spChar">T</span>ense
				</div>
				<TenseOptions updateInput={(key, value)=>updateInput(key, value)}/>
			</Col>
			<Col md className="interfaceCol">
				<div className="colHeader">
					<span className="spChar">V</span>oice
				</div>
				<VoiceOptions updateInput={(key, value)=>updateInput(key, value)}/>
			</Col>
			<Col md className="interfaceCol">
				<div className="colHeader">
					<span className="spChar">P</span>erson
				</div>
				<PersonOptions updateInput={(key, value)=>updateInput(key, value)}/>
			</Col>
			<Col md className="interfaceCol">
				<div className="colHeader">
					<span className="spChar">N</span>umber
				</div>
				<NumberOptions updateInput={(key, value)=>updateInput(key, value)}/>
			</Col>
		</Row>
		
		</>
	);
};

export default Verb;